import React, { Component } from 'react';
import CadessWarning from './CadessWarning';

class CadessWarningContainer extends Component {
  state = {
    displayWarning: true,
  };

  toggleDisplay = () => {
    this.setState(prevState => ({
      displayWarning: !prevState.displayWarning,
    }));
  };

  render() {
    const { warning } = this.props;
    const { displayWarning } = this.state;
    return (
      <>
        {warning && <CadessWarning warning={warning} displayWarning={displayWarning} handleClick={this.toggleDisplay}/>}
      </>
    );
  }
}

export default CadessWarningContainer;
